<template>
    <transition name="modal-fade">
        <div class="modal-wrapper">
            <div class="modal flex flex-col overflow-y-visible"
                :class="cssClass"
                role="dialog"
                aria-labelledby="modalTitle"
                aria-describedby="modalDescription">
                <header class="modal-header" id="modalTitle">
                    <slot name="header">
                    </slot>
                </header>
                <button
                type="button"
                class="btn-close"
                @click="close('Modal closed')"
                aria-label="Close modal"
                >
                    <feather type="x"></feather>
                </button>
                <section class="modal-body" id="modalDescription">
                    <slot name="body">
                    </slot>
                </section>
                <footer class="modal-footer">
                    <slot name="footer">
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>
<script>

import ModalMixin from '../mixins/ModalMixin';

export default {
  mixins: [ModalMixin],
  data(){
      return {
          cssClass: '',
      }
  },
  mounted(){
      if(this.$attrs.size && this.$attrs.size.length) this.cssClass = this.$attrs.size
      else this.cssClass = 'w-screen h-screen md:h-auto md:max-w-3xl md:w-9/12 md:rounded-3xl'
  }
}
</script>
<style lang="sass">
.modal-wrapper
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    justify-content: center
    align-items: center
    z-index: 10
.modal
    background: #FFFFFF
    box-shadow: 0px 7px 7px rgba(0, 0, 0, 0.03), 0px 4px 2px rgba(0, 0, 0, 0.03)
    overflow-x: auto
    min-width: 400px
    min-height: 150px
    position: relative
    max-height: 100vh
    &-header,&-footer
        padding: 20px
        display: flex
        border: none
        &:before, &:after
            display: none
    &-header
        justify-content: space-between
        margin-right: 40px
        padding-bottom: 0
        min-height: 50px
    .btn
        justify-content: center
        align-items: center
        i
            margin-right: 0.5rem
    .btn-primary
        display: flex
    .btn-close
        position: absolute
        top: 0
        right: 0
        border: none
        font-size: 20px
        padding: 20px
        cursor: pointer
        background: transparent
        outline: none
    &-footer
        flex-direction: column
        justify-content: flex-end
    &-body
        position: relative
        padding: 20px
        overflow-y: visible
        height: inherit
</style>
